import ReactOnRails from 'react-on-rails';

import Favorite from '../components/Favorite';
import Toast from '../components/Toast';
import FashionIcon from '../components/FashionIcon';
import FashionLocationTypeahead from '../components/FashionLocationTypeahead';
import Footer from '../components/Footer';
import Header from '../components/Header';
import HeroImage from '../components/HeroImage';
import LinkAgent from '../components/LinkAgent';
import MoreInThisCollectionCarousel from '../components/MoreInThisCollectionCarousel';
import Spinner from '../components/Spinner';
import ThumbImage from '../components/ThumbImage';
import TkLinks from '../components/TkLinks.jsx';
import { DesignerWebsiteLink } from '../components/DesignerWebsiteLink';
import {TopBreadcrumb, BottomBreadcrumb} from '../components/Breadcrumb';
import HeroSection from '../components/HeroSection';
import ResultsComponent from '../components/ResultsComponent';
import FeaturedDesignersComponent from '../components/FeaturedDesignersComponent.jsx'
import QuizBanner from '../components/QuizBanner'
import TKRetakeBanner from '../components/RetakeBanner';
import ReadMoreComponent from '../components/ReadMoreComponent.jsx';

ReactOnRails.register({
  TKRetakeBanner,
  Header,
  TopBreadcrumb,
  LinkAgent,
  TkLinks,
  DesignerWebsiteLink,
  Favorite,
  HeroImage,
  ThumbImage,
  FashionIcon,
  FashionLocationTypeahead,
  Spinner,
  MoreInThisCollectionCarousel,
  BottomBreadcrumb,
  Toast,
  Footer,
  HeroSection,
  ResultsComponent,
  FeaturedDesignersComponent,
  QuizBanner,
  ReadMoreComponent
});
